<div class="p-3">
  <div class="pt-5">
    <div class="text-2xl font-bold justify-content-left align-items-center flex gap-3 py-3">
      <i class="pi pi-lock" style="font-size: 1.5rem"></i>
      Restricted access
    </div>
    <div>
      <i>You are not authorized to view this page.</i>
    </div>
    <div class="pt-3">
      Please select an item from the menu on the left or visit our <a class="internal-link"
        href="/portal-home">homepage</a>.
    </div>
  </div>
</div>